<template>
	<el-autocomplete ref="elAutocomplete" focus class="inline-input" v-model.trim="state" :fetch-suggestions="querySearch" placeholder="请输入内容"
		@select="handleSelect" @blur='autoSelect' v-bind='option' @clear='clear' clearable></el-autocomplete>
</template>

<script>
	export default {
		props: {
			//搜索数据
			searchDataList: Array,
			option: Object
		},
		data() {
			return {
				state: '',
				
			}
		},
		methods: {
			clear(){
				//重新激活elAutocomplete 弹出列表
				this.$refs.elAutocomplete.activated = true
				this.$emit('handleSelect', {})
			},
			querySearch(queryString, cb) {
				var restaurants = this.searchDataList;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;

				cb(results);
			},
			createFilter(queryString) {

				return (restaurant) => {
					//默认value
					return (restaurant[this.option?.valueKey || 'value'].toLowerCase().indexOf(queryString
					.toLowerCase()) === 0);
				};
			},
			handleSelect(item) {
				this.$emit('handleSelect', item)
			},
			//主动匹配
			autoSelect() {
				let res= this.searchDataList.find((item) => {
					return item[this.option?.valueKey || 'value'] == this.state
				})
				// console.log(res)
				this.$emit('handleSelect', res||{})
			},

		},

		
	}
</script>

<style lang="scss" scoped>

</style>
